import { gql } from 'apollo-angular';

export var update_committee_link = gql`
  mutation updateCommitteeLink($input: CommitteeLinkInput!) {
    updateCommitteeLink(input: $input) {
      id
      name
      url
      milestone_id
      is_package
      is_default_link
    }
  }
`;
